export const emptyCellCharacter = '—';

export const LEGACY_TEACHING_YEAR_LIMIT = 2022;
